export default {
	SET_DATA_LOADED: (state, bool) => {
		state.dataLoaded = bool;
	},
	SET_DATA_LOADING: (state, bool) => {
		state.dataLoading = bool;
	},
	SET_MAIN_SIDEBAR_OPEN_STATE: (state, bool) => {
		state.mainSidebarOpenState = bool;
		localStorage.setItem("mainSidebarOpenState", String(bool));
	},
	SET_ACCOUNT_SIDEBAR_OPEN_STATE: (state, bool) => {
		state.secondSidebarOpenState = bool;
		localStorage.setItem("secondSidebarOpenState", String(bool));
	},
	SET_ACCOUNT_SUBMENU_OPEN_STATE: (state, bool) => {
		state.accountSubmenuOpenState = bool;
		localStorage.setItem("accountSubmenuOpenState", String(bool));
	},
	SET_EVENT_SUBMENU_OPEN_STATE: (state, bool) => {
		state.eventSubmenuOpenState = bool;
		localStorage.setItem("eventSubmenuOpenState", String(bool));
	},
	SET_MERCHANDISE_SUBMENU_OPEN_STATE: (state, bool) => {
		state.merchandiseSubmenuOpenState = bool;
		localStorage.setItem("merchandiseSubmenuOpenState", String(bool));
	},
	SET_NOTIFICATIONS_STATE: (state, bool) => {
		state.notificationsState = bool;
	},
	SET_NOTIFICATIONS: (state, arr) => {
		state.notifications = arr;
	},
	SET_LOGGED_OUT: (state, bool) => {
		state.loggedOut = bool;
	},
	SET_SESSION_EXPIRATION: (state, string) => {
		state.logoutTime = string;
		localStorage.setItem("logoutTime", string);
	},
	SET_SEARCH_TERM: (state, string) => {
		state.searchTerm = string;
		localStorage.setItem("searchTerm", string);
	},

	REMOVE_LOGOUT_TIME: (state) => {
		state.logoutTime = 0;
		localStorage.removeItem("logoutTime");
	},
};
